import React, { useContext } from 'react';
import {
    getCoreRowModel,
    getSortedRowModel,
    useReactTable,
} from '@tanstack/react-table';
import { Grid } from '@mui/material';
import Table from 'Components/Table/index';
import InvitationsColumns from './InvitationsColumns';
import UserContext from '../context/UsersContext';
import { Invitation } from 'generated/graphql';

const InvitationsTable: React.FC = () => {
    const { searchFilters, invitationsTable, invitations } =
        useContext(UserContext);

    const tableProps = useReactTable({
        columns: InvitationsColumns,
        data: searchFilters.length > 0 ? invitationsTable : invitations,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
    });

    return (
        <Grid item xs={12} mt={4}>
            <Table<Invitation>
                containerSx={{ maxHeight: '600px', overflow: 'auto' }}
                tableProps={tableProps}
                stickyHeader
                canSort
            />
        </Grid>
    );
};

export default InvitationsTable;
